export const setFooterSticky = () => ({
    type: 'STICKY',
});